import React from 'react'
import "../css/about.css"
import { IoThumbsUpOutline } from "react-icons/io5";
import { FaLongArrowAltRight } from "react-icons/fa";




const About = () => {
  const handleDownload = () => {
    const pdfUrl = process.env.PUBLIC_URL + '/Abraham_cv.pdf';
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Abraham-cv.pdf'; // Remove the dot at the beginning
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
  
    <div className='aboutcontainer bg-[#faf5ff]'>
        <div className='aboutMain bg-[#faf5ff] text-[#021D44]'>
              <div className='headAbout'>
               <div className='meetme flex items-center'>
              <p>Meet me</p>   
               <IoThumbsUpOutline></IoThumbsUpOutline>  
               </div>
                <div className='whoAbout'>
                   
                <p>My name is Olowu Abraham, also known as "the true villain," and I am a Frontend Developer who embarked on my career journey in 2020, amidst the challenges posed by the pandemic, while I was
                   still a student. My technological odyssey has been nothing short of remarkable, and I attribute much of my success to the invaluable impact of Altschool Africa.</p> 

                   <p>
                   As a Frontend Engineer, my expertise spans a range of technologies, including HTML, CSS, Javascript, React, Restful API, Vue, and Next.js.
                    Despite my academic background in Material and Metallurgical Engineering, I have transitioned into the field of software engineering, where my passion for the industry continues to drive my aspirations for further growth.
                   </p>

                   <p>
                   Beyond the realms of coding, I am an avid enthusiast of football, boxing, and politics, which provides a well-rounded perspective to complement my technical skills.                   </p>

                   <p>
                   In terms of professional pursuits, my primary focus lies in the development of websites and web applications. I specialize in utilizing technologies such as React, Next.js, and Vue to create seamless 
                   and dynamic online experiences. My commitment to staying abreast of the latest industry trends ensures that I deliver cutting-edge solutions to meet the evolving needs of the digital landscape.      
                    </p>
                   

                </div>
              </div>




               <div className='WhatAbout'>
                  <div className='WhatAboutHeader'>What I do</div>
                  <div>
                    I develop website and web applications using React, Next and Vue.
                  </div>
               </div>

               <div className='Hire'>
                <div className='Hirehead'>Available for hire</div>
                <div className='Hiredown cursor-pointer'  onClick={handleDownload}>
              <p>Download cv</p>
              <FaLongArrowAltRight className="right1" />
            </div>
               </div>
         </div>
      

    </div>

  
  )
}

export default About
